import * as React from "react"
import type { SVGProps } from "react"
const SvgCloseMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8.5 9.38 5.58 12.3a1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28 1 1 0 0 1-.28-.7q0-.42.28-.7L7.1 7.97 4.18 5.08a1 1 0 0 1-.28-.7q0-.42.28-.7a1 1 0 0 1 .7-.28q.42 0 .7.28L8.5 6.6l2.9-2.92a1 1 0 0 1 .7-.28q.43 0 .7.28.3.3.3.7 0 .42-.3.7l-2.92 2.9 2.92 2.91q.27.28.28.7c0 .43-.1.53-.28.71q-.3.3-.71.3a1 1 0 0 1-.69-.3z" />
  </svg>
)
export default SvgCloseMini
